import { z } from 'zod/v3';
import { errorMap } from './errorMap';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './zSequenceNumber.translations.json';

const { addTranslations, t } = i18nNsFactory('sequence-number');
addTranslations(translations);

export const zSequenceNumber = (...args: Parameters<typeof z.number>) =>
  z.coerce
    .number({
      ...args[0],
      ...errorMap(() => t('required')),
    })
    .min(1);
